/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_HelpInputs */



/**
* | output |
* | --- |
* | "Enter a name for this group" |
*
* @param {Team_Manager_Group_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_help = /** @type {((inputs?: Team_Manager_Group_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez un nom pour ce groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Namen für diese Gruppe ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per questo gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название для этой группы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre para este grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入该组的名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このグループの名前を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस समूह के लिए एक नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira um nome para este grupo.")
	return /** @type {LocalizedString} */ ("Enter a name for this group")
});